<div class="flex flex-column gap-2">
  <div class="basis-1/2">
    <nx-table-header class="text-[1rem]" [label]="'Aufgabentypen'">
      <ng-template nxTemplate="end">
      </ng-template>
    </nx-table-header>
    <p-table #taskTypesTable
      [lazy]="true"
      (onLazyLoad)="loadData($event)"
      [value]="dataSource?.data"
      [scrollable]="true"
      [paginator]="false" 
      [rows]="15"
      selectionMode="single" 
      [(selection)]=dataSource.selectedTaskType
      dataKey="code" 
      (onRowSelect)="setMenuItems()"
      [rowsPerPageOptions]="[15, 20, 50]"
      [totalRecords]="dataSource?.totalElements"
      [sortField]="sortProperty"
      [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} von {totalRecords}"
      [resizableColumns]="true">
      <ng-template pTemplate="caption">
        <div class="flex flex-row">
          <div class="basis-2/3 flex flex-row gap-2">
          </div>
          <div class="basis-1/3 flex flex-row justify-end">
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="min-width: 3rem; width: 3rem;">Icon</th>
          <th style="min-width: 5rem; width: 8rem;">Name</th>
          <th style="min-width: 3rem; width: 3rem;">Aktiv</th>
          <th style="min-width: 3rem; width: 3rem;">System</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-taskType>
        <tr class="clickable" [pSelectableRow]="taskType">
          <td>
            <i class="relative top-[-1px] left-[-2px] text-[30px]" [ngClass]="taskType.icon"></i>
          </td>
          <td>
            {{taskType.name}}
          </td>
          <td>
            <input type="checkbox" [checked]="taskType?.isActive" disabled />
          </td>
          <td> 
            <input type="checkbox" [checked]="taskType?.isSystem" disabled />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="emptyMessage">Keine Status Typen gefunden.</td>
        </tr>
      </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
    </ng-template>
  </div>
  <div class="basis-1/2">
    <nx-headline-box
      [label]="'Einstellungen'">
      <ng-template nxTemplate="end">
      </ng-template>
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Name'">
      {{dataSource?.selectedTaskType?.name}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Farbe'">
      <span 
        class="inline-block w-3 h-3 rounded-sm align-middle mr-1 border border-gray-300"
        [ngStyle]="{ 'background-color': dataSource?.selectedTaskType?.color }">
      </span>
      {{dataSource?.selectedTaskType?.color}}
    </nx-default-box>
    
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Icon'">
      <i class="relative top-[-1px] left-[-2px] text-[30px]" [ngClass]="dataSource?.selectedTaskType?.icon"></i>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'System'">
      <input type="checkbox" [checked]="dataSource?.selectedTaskType?.isActive" disabled />
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'Aktiv'">
      <input type="checkbox" [checked]="dataSource?.selectedTaskType?.isSystem" disabled />
    </nx-default-box>

  </div>
</div>